import { ApiState } from '../utils/requestAction';
import { Configuration } from '../models/Configuration';
import requestReducer from './requestReducer';

export interface ConfigState extends ApiState {
  config?: Configuration
}

export default requestReducer<ConfigState>('CONFIG')